import { useEffect } from 'react';
import dayjs from 'dayjs';
import { useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { Row, Col, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import EventSessionOffcanvas from './components/EventSessionOffcanvas';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { getDates } from '../../../../_helpers/_methods';
import LoadingComponent from '../../../../Components/LoadingComponent';
import EventBar from './components/EventBar';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import NepaliDate from 'nepali-date-converter';
// import { BsClockHistory, BsFillJournalBookmarkFill } from 'react-icons/bs';
import DownloadBtn from '../../../../Components/Buttons/DownloadBtn';
import { checkPermission } from '../../../../_helpers/roles/check-roles';

function EventSessions() {
  const active_role = useSelector((state) => state?.user?.user?.active_role);
  const { event } = useSelector((state) => state.event);
  const local = useSelector((state) => state.local.local);
  const [eventDays, setEventDays] = useState({});
  const [sessions, setSessions] = useState([]);
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loadingSession, setLoadingSession] = useState(true);
  const completed = useSelector((state) => state.event.event.completed);
  useEffect(() => {
    const getSesson = async () => {
      try {
        setLoadingSession(true);
        const response = await fetchWrapper.get(`/event/${event.id}/session/`);
        if (response) {
          setSessions(response?.data);
        }
        setLoadingSession(false);
      } catch (error) {
        setLoadingSession(false);
        console.log(error);
      }
    };

    if (event?.id && !show) {
      getSesson();
    }
  }, [event?.id, show]);
  useEffect(() => {
    const setEventDayHandler = () => {
      let startdate = event.start_date;
      let enddate = event.end_date;

      let eventDaysArray = getDates(startdate, enddate);
      let eventDaysObj = {};
      eventDaysArray.forEach((date) => {
        eventDaysObj[dayjs(date).format('YYYY-MM-DD')] = [];
      });
      let sessionObj = {};
      sessions.forEach((session) => {
        let tempSessionEvent = [...session.events];
        tempSessionEvent = tempSessionEvent.sort((a, b) =>
          Number(a.start_time.split(':').join('')) > Number(b.start_time.split(':').join(''))
            ? 1
            : -1
        );
        sessionObj[session.date] = tempSessionEvent;
      });
      eventDaysObj = {
        ...eventDaysObj,
        ...sessionObj
      };
      setEventDays(eventDaysObj);
    };
    setEventDayHandler();
  }, [sessions]);

  const handleShowSessonModal = (eventDateId) => {
    setEditData(null);
    setShow(eventDateId);
  };

  const handleClose = () => {
    setShow(false);
  };
  const handleDeleteSesson = async (event, callBack) => {
    try {
      setLoadingSession(true);
      await fetchWrapper.delete(`/event/session/${event.id}/`);
      let tempSessions = [...sessions];
      let indexOfDayEvents = tempSessions.findIndex((session) => session.date === event.date);
      let tempDayEvents = tempSessions[indexOfDayEvents].events;
      tempDayEvents = tempDayEvents.filter((dayEvent) => dayEvent.id !== event.id);
      tempSessions[indexOfDayEvents].events = tempDayEvents;
      setSessions(tempSessions);
      callBack();
      setLoadingSession(false);
    } catch (error) {
      setLoadingSession(false);
      console.log(error);
    }
  };

  const handleEdit = (event) => {
    setShow(event.date);
    setEditData(event);
  };

  return (
    <div className="card">
      <div className="card-header">
        <div className="d-flex justify-content-end">
          {checkPermission(active_role, 'export files') && (
            <>
              <DownloadBtn
                apiUrl={`/report/each-event/session/?event_id=${event.id}&type=excel`}
                type="excel"
              />
              <DownloadBtn
                apiUrl={`/report/each-event/session/?event_id=${event.id}&type=pdf`}
                type="pdf"
              />
            </>
          )}
        </div>
      </div>
      <div className="card-body">
        <div className="border-right">
          {loadingSession ? (
            <LoadingComponent />
          ) : (
            Object.keys(eventDays).map((eventDay) => {
              const events = eventDays[eventDay];
              const nepaliDate = new NepaliDate(new Date(eventDay));
              return (
                <div className="my-2" key={eventDay}>
                  <EventRow className="">
                    <Col sm={1} className="border-right p-0">
                      <div className="border-right text-center border-primary">
                        <h5 className="font-weight-bold text-secondary text-center mb-0">
                          {local === 'ne'
                            ? nepaliDate.format('dd', 'np')
                            : dayjs(eventDay).format('ddd')}
                        </h5>
                        <p className="font-weight-bold text-blue text-center mb-0">
                          {local === 'ne'
                            ? nepaliDate.format('DD MMMM', 'np')
                            : nepaliDate.format('DD MMMM', 'en')}
                        </p>
                        {!completed && checkPermission(active_role, 'create session') ? (
                          <Button
                            className="addBtn"
                            onClick={() => handleShowSessonModal(eventDay)}>
                            <span className="d-flex align-items-center">
                              <FaPlus />
                              <span className="ms-2">{local === 'ne' ? 'सेसन' : 'Session'}</span>
                            </span>
                          </Button>
                        ) : null}
                      </div>
                    </Col>
                    <Col sm="11">
                      {events.length === 0 ? (
                        <p className="bg-light text-center p-2 text-muted sessionTitle">
                          {!completed && checkPermission(active_role, 'create session') ? (
                            <FormattedMessage id="event.session.noSessionMessageCreate" />
                          ) : (
                            <FormattedMessage id="event.session.noSessionMessage" />
                          )}
                        </p>
                      ) : (
                        events.map((eve) => {
                          return (
                            <EventBar
                              key={eve.id}
                              event={eve}
                              handleDelete={handleDeleteSesson}
                              handleEdit={handleEdit}
                              hasEventCompleted={completed}
                            />
                          );
                        })
                      )}
                    </Col>
                  </EventRow>
                </div>
              );
            })
          )}
        </div>
        {show && (
          <EventSessionOffcanvas show={show} handleClose={handleClose} editData={editData} />
        )}
      </div>
    </div>
  );
}

export default EventSessions;

const EventRow = styled(Row)`
  .addBtn {
    margin-top: 0.5rem;
    border-radius: 1000px;
    padding: 0.2rem 0.75rem;
  }
`;
